import { useMemo, useEffect, useRef } from "react";
import React from "react";
import clsx from "clsx";
import FTLTableStyles from "../../styles/FTLTableStyles.styles";
import FTLSectionHeader from "../FTLSectionHeader";
import FTLTableCell from "../FTLTableCell";
import FTLTableRow from "../FTLTableRow";
import { useComponentDimensions } from "../../../../..";
const RowComponents = ({ rows, rowHeight, prepareRow, rowDisable, onRowClick, rowProps, isFetching, hasData, noCellBorder, actionComponent: ActionComponent, setActionComponentWidth, tableOffsetWidth, sectionHeaderCounterData, sectionHeaderActionButtons, sectionHeaderTitleAccessor, classes: classesFromProps, }) => {
    const actionComponentRef = useRef(null);
    const { clientWidth: actionComponentWidth } = useComponentDimensions(actionComponentRef);
    const classes = FTLTableStyles();
    useEffect(() => {
        setActionComponentWidth(actionComponentWidth);
    }, [actionComponentWidth]);
    return (React.createElement(React.Fragment, null, useMemo(() => {
        return rows.map((row) => {
            prepareRow(row);
            const isDisabled = row.isDisabled || (rowDisable && rowDisable(row));
            const props = rowProps && rowProps(row);
            const canInteract = !isFetching && hasData && (onRowClick || ActionComponent);
            return (React.createElement(FTLTableRow, Object.assign({}, row.getRowProps(), props, { key: row.id, className: clsx(classesFromProps === null || classesFromProps === void 0 ? void 0 : classesFromProps.row, canInteract && classes.rowHoverStyle), noCellBorder: noCellBorder, "data-disabled": isDisabled, onClick: (e) => {
                    var _a;
                    if (!isFetching &&
                        hasData &&
                        onRowClick &&
                        !((_a = document.getSelection()) === null || _a === void 0 ? void 0 : _a.toString()))
                        onRowClick(row, e);
                } }),
                React.createElement(React.Fragment, null,
                    row.canExpand ? (React.createElement(FTLSectionHeader, { sectionHeaderCounterData: sectionHeaderCounterData, tableOffsetWidth: tableOffsetWidth, getToggleRowExpandedProps: row.getToggleRowExpandedProps, sectionHeaderActionButtons: sectionHeaderActionButtons, sectionHeaderTitleAccessor: sectionHeaderTitleAccessor, row: row })) : (row.cells.map((cell, cellIndex) => {
                        var _a;
                        const widthProps = typeof cell.column.width === "number"
                            ? {
                                minWidth: cell.column.width ||
                                    cell.column.minWidth ||
                                    cell.column.maxWidth,
                            }
                            : {
                                width: cell.column.width,
                                minWidth: cell.column.minWidth,
                                maxWidth: cell.column.maxWidth,
                            };
                        return (React.createElement(FTLTableCell, Object.assign({}, cell.getCellProps(), { isDisabled: typeof cell.value === "object" ? false : isDisabled, key: row.id + cellIndex, noCellBorder: noCellBorder, tabIndex: -1, textAlign: ((_a = cell.column) === null || _a === void 0 ? void 0 : _a.align) || "left" }, widthProps, { className: clsx(cell.column.showOnHover && classes.showOnHover, classesFromProps === null || classesFromProps === void 0 ? void 0 : classesFromProps.cell), height: cell.column.showOnHover ? rowHeight : undefined }), cell.value !== undefined ||
                            cell.column.type === "skeleton" ||
                            (typeof cell.column.Cell === "function" &&
                                (cell.column.Cell.name === "" ||
                                    cell.column.Cell.name === "Cell"))
                            ? cell.render("Cell")
                            : "—"));
                    })),
                    canInteract && ActionComponent && (React.createElement("div", { ref: actionComponentRef },
                        React.createElement("div", null, ActionComponent(row)))))));
        });
    }, [
        rows,
        isFetching,
        hasData,
        prepareRow,
        rowDisable,
        onRowClick,
        rowProps,
        ActionComponent,
        tableOffsetWidth,
        sectionHeaderCounterData,
        sectionHeaderActionButtons,
        sectionHeaderTitleAccessor,
        setActionComponentWidth,
        actionComponentRef,
    ])));
};
export default RowComponents;
//# sourceMappingURL=RowComponents.js.map